import cc from "classcat"
import { handleLinks } from "utils/handleLinks"
import Divided from "components/organisms/common/Divided"

const ListItem = ({
  numberColor = "text-kkm-green",
  title,
  number,
  className,
  theme,
}) => {
  return (
    <li className={cc(["flex space-x-4 py-6", className])}>
      <div
        className={cc([
          "flex shrink-0 flex-col justify-center pt-1 font-display text-4xl font-bold",
          numberColor,
        ])}
      >
        {number}
      </div>
      <div className="flex flex-col justify-center space-y-2">
        <p
          className={cc([
            "m-0 font-display text-lg",
            {
              "text-zinc-800": theme !== "dark",
              "text-zinc-100": theme === "dark",
            },
          ])}
        >
          {handleLinks(title)}
        </p>
      </div>
    </li>
  )
}

export default function NumberedList({
  title,
  items,
  Image,
  theme = "light",
  reversed,
}) {
  return (
    <Divided
      Image={Image}
      title={title}
      theme={theme}
      reversed={reversed}
      titleSize="md"
    >
      <ol className="m-0 list-none divide-y-2 divide-kkm-green border-b-2 border-t-2 border-kkm-green">
        {items.map((item) => (
          <ListItem {...item} theme={theme} />
        ))}
      </ol>
    </Divided>
  )
}
